import React from 'react'
import SvgIcon from 'rambler-ui/icons/SvgIcon'

export default function Safety ({className}) {
  return (
    <SvgIcon
      color='currentColor'
      style={{
        display: 'block'
      }}
      className={className}
      viewBox={`0 0 100 100`}>
      <g
        fill='none'
        fillRule='evenodd'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='2.3'>
        <path
          stroke='#649DFF'
          d='M41.268 96.91s21.968-4.431 31.395-24.38c6.49-13.728 6.453-42.503 6.442-44.53-14.173-.943-27.19-5.78-37.837-13.385-10.645 7.606-23.663 12.442-37.837 13.384-.01 2.028-.048 30.803 6.442 44.53 9.43 19.95 31.395 24.382 31.395 24.382z'
        />
        <path stroke='#274BC8' d='M28.63 69.984h25.073v-17.4H28.631z' />
        <path
          stroke='#274BC8'
          d='M28.786 52.584c0-6.838 5.543-12.382 12.381-12.382 6.837 0 12.38 5.544 12.38 12.382'
        />
        <path
          stroke='#649DFF'
          d='M39.075 61.284a2.092 2.092 0 1 1 4.183 0 2.092 2.092 0 0 1-4.183 0z'
        />
      </g>
    </SvgIcon>
  )
}
